import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuesax from 'vuesax'
import moment from 'moment'

import 'vuesax/dist/vuesax.css' //Vuesax styles



//fontawesome setup start

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faQuestionCircle,faSort,faSortDown,faBars,faSignOutAlt,faClipboardList,faCalendarAlt,faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret,faQuestionCircle,faSort,faSortDown,faBars,faSignOutAlt,faClipboardList,faCalendarAlt,faTimes)

// import vuetify from 'vue-cli-plugin-vuetify' // path to vuetify export
import vuetify from '@/plugins/vuetify' // path to vuetify export



Vue.component('font-awesome-icon', FontAwesomeIcon)
// font awesome setup end

Vue.use(Vuesax, {
  // options here
})

Vue.prototype.moment = moment

Vue.config.productionTip = false


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
